<template>
    <div>
        <multiselect v-model="values"
                     :options="options"
                     :height="250"
                     :hide-selected="true"
                     :multiple="multiple"
                     @search-change="asyncFind"
                     :close-on-select="closeOnSelect"
                     :clear-on-select="false"
                     :preserve-search="true"
                     :placeholder="placeholder"
                     open-direction="below"
                     :show-labels="true"
                     label="label"
                     :value="value"
                     track-by="id">
            <template v-if="isShort" slot="selection" slot-scope="{ values, search, isOpen }"><span
                class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                    values.length
                }} options selected</span></template>
        </multiselect>

        <input v-if="!multiple" :id="name" v-model="this.value" :name="name" type="hidden">
        <template v-else>
            <input v-for="value in values" :id="name" :name="name+'[]'" :value="value.id" type="hidden">
        </template>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import _ from 'lodash';

export default {
    name: "MultipleSelectComponent",
    components: {Multiselect},
    props: {
        placeholder: {
            default: 'Pick some'
        },
        name: {
            default: 'multiselect'
        },
        preselectFirst: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: true
        },
        urlSearch: {
            type: String,
            default: ''
        },
        urlShow: {
            type: String,
            default: ''
        },
        selected: {
            type: Array,
            required: false
        },
        mutation: {
            type: String,
            default: null
        },
        isShort: {
            type: Boolean,
            default: false
        },
        closeOnSelect: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            editing: false,
            values: [],
            value: null,
            options: []
        }
    },
    watch: {
        values(val) {
            if (this.mutation) {
                this.$store.commit(this.mutation, this.values)
            }
            if (!this.multiple){
                this.value = this.values.id
            }
        }
    },
    mounted() {
       this.setInMounted()
    },
    methods: {
        async setInMounted() {
            if (this.selected.length > 0) {
                this.editing = true
                console.log(this.selected)
                await this.getData(this.selected)
                if (!this.multiple) {
                    this.value = this.selected[0]
                }

            }
        },
        asyncFind(query) {
            this.isLoading = true
            var vm = this;
            axios.get(this.urlSearch + `?search=${escape(query)}`)
                .then((response) => {
                    vm.options = response.data
                })
                .catch(error => {

                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {

                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);

                })
                .finally(() => {
                    this.$loading(false);
                });

        },
            async getData(ids) {
                var vm = this;
                let url = this.urlShow ? this.urlShow : this.urlSearch;

                ids = ids.map(function (el, index) {
                    return `ids[${index}]=${el}`
                }).join('&');
                await axios.get(url + `?${ids}`)
                    .then((response) => {

                        vm.values = response.data
                    })
                    .catch(error => {

                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {

                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);

                    })
            }
    }
}
</script>

<style scoped>

</style>
